export default __webpack_public_path__ + "media/images/logo-stacked-f9f0b4dba4a3660bdded2424f15f8bb8.png";